<template>
    <div class="pa-2 rounded-lg">
      <div class="d-flex align-center justify-space-between mb-2">
        <div>
          <span class="font-weight-black">
            {{ frente.descripcion }}
          </span>
        </div>
        <div>
          <v-btn v-if="!soloLectura" icon small
          @click="agregarActividad">
            <v-icon>
              mdi-plus
            </v-icon>
          </v-btn>
        </div>
      </div>
      <v-card flat>
        <v-card-text>
          <template v-for="actividad in getcontratoDiarioActividadesPorFrente">
            <template>
              <CardActividad
              :soloLectura="soloLectura"
              :key="actividad.id"
              :actividad="actividad" />
            </template>
          </template>
        </v-card-text>
      </v-card>
    </div>
</template>

<script>
import CONTRATO_DIARIO_ACTIVIDADES_POR_FRENTE from '@/graphql/querys/administracion/contratos/contrato/diarioactividades/contratoDiarioActividadesPorFrente.gql';
import CardActividad from './CardActividad.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'CardFrentes',
  props: {
    frente: {
      type: Object,
      required: true,
    },
    soloLectura: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    CardActividad,
  },
  data() {
    return {};
  },
  apollo: {
    contratoDiarioActividadesPorFrente: {
      query: CONTRATO_DIARIO_ACTIVIDADES_POR_FRENTE,
      variables() {
        return {
          idContratoFrente: this.frente.id,
          pagina: 1,
          numeroRegistros: 10,
        };
      },
    },
  },
  computed: {
    getcontratoDiarioActividadesPorFrente() {
      if (!this.contratoDiarioActividadesPorFrente) return [];
      return this.contratoDiarioActividadesPorFrente;
    },
  },
  methods: {
    agregarActividad() {
      eventBus.$emit('registrar-actividad-contrato', this.frente);
    },
  },
};
</script>

<style lang="scss" scoped></style>
